import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-logout-page',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
